import {
  AuthProvider as OidcAuthProvider,
  useAuthContext,
} from "../oidc-client-auth/AuthProvider";

export interface AuthContextType {
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (redirectTo?: string) => Promise<void>;
  logout: () => Promise<void>;
  syncUserFromStorage: () => Promise<void>;
}

export const AuthProvider = OidcAuthProvider;

/** Full auth context (getUserManager, user, profile, accessToken, renew). Use when you need more than useAuth(). */
export { useAuthContext };

export const useAuth = (): AuthContextType => {
  const { isAuthenticated, isLoading, login, logout, syncUserFromStorage } =
    useAuthContext();
  return { isAuthenticated, isLoading, login, logout, syncUserFromStorage };
};
